import { ref } from "#imports";
const miniature = ref("");
function showHoverMiniature(str) {
  miniature.value = str;
}
function hideHoverMiniature() {
  miniature.value = "";
}
export default () => ({
  miniature,
  showHoverMiniature,
  hideHoverMiniature
});
